{
    "Accessibility menu": "アクセシビリティメニュー",
    "Close": "閉じる",
    "Content adjustments": "コンテンツ調整",
    "Navigation adjustments": "ナビゲーション調整",
    "Text Align": "Text Align",
    "Align Left": "左揃え",
    "Align Center": "Align Center",
    "Align Right": "Align Right",
    "Adjust Font Size": "フォントサイズ調整",
    "Highlight Title": "タイトルを強調",
    "Highlight Links": "リンクを強調",
    "Readable Font": "読みやすいフォント",
    "Colour adjustments": "色調整",
    "Dark Contrast": "暗いコントラスト",
    "Light Contrast": "明るいコントラスト",
    "High Contrast": "高コントラスト",
    "High Saturation": "高彩度",
    "Low Saturation": "低彩度",
    "Monochrome": "モノクロ",
    "Tools": "ツール",
    "Reading Guide": "リーディングガイド",
    "Big Cursor": "大きなカーソル",
    "Increase Font Size": "フォントサイズ拡大",
    "Decrease Font Size": "フォントサイズ縮小",
    "Letter Spacing": "文字間隔",
    "Line Height": "行の高さ",
    "Font Weight": "フォントの太さ",
    "Dyslexia Font": "ディスレクシア用フォント",
    "Language": "言語",
    "Accessibility widget": "アクセシビリティメニューを開く",
    "Accessibility Profiles": "アクセシビリティプロファイル",
    "Cognitive Disability": "認知障害",
    "Seizure Safe": "発作安全",
    "Accessibility statement": "アクセシビリティステートメント",
    "ADHD": "ADHD",
    "Low Vision": "Low Vision",
    "Pause Animations": "アニメーション停止",
    "Reset all settings": "設定をリセット",
    "Shortcut:": "Shortcut:",
    "Epilepsy Safe Mode": "Epilepsy Safe Mode",
    "Mute sounds": "Mute sounds",
    "Page read": "Page read",
    "Page read controls": "Page read controls",
    "Pause": "Pause",
    "Resume": "Resume",
    "Stop": "Stop",
    "Settings": "Settings",
    "Speed": "Speed",
    "Voice": "Voice"
}
